import FormattedMessage from 'I18n/components/FormattedMessage';
import { useContext } from 'react';
import UILink from 'UIComponents/link/UILink';
import UIBreadcrumbs from 'UIComponents/nav/UIBreadcrumbs';
import { useEditorActions } from '../../hooks/useEditorActions';
import { useFilterFamilyOptions } from '../../hooks/useFilterFamilyOptions';
import { useStrategy } from '../../hooks/useStrategy';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { hasCombinedFilterFamilyAndFieldSelectPanel } from '../../permissions/gates';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorFilterSelectBreadcrumbs = () => {
  const {
    conditionPathToChangeFieldFor,
    conditionToRefineKeyPath,
    draftCondition,
    getIsUngated,
    selectedFilterFamilyGroup,
    selectedFilterFamily,
    props: {
      baseFilterFamily,
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    getFilterFamilyName
  } = useStrategy();
  const {
    getTopLevelFilterFamilyOptionLabel,
    hasOnlyOneFilterFamilyOption
  } = useFilterFamilyOptions();
  const {
    resetFilterCategorySelect
  } = useEditorActions();
  const isFilterFamilyPredefined = Boolean(draftCondition && draftCondition.isAddingNew && draftCondition.filterFamily);
  const disableAllCategoriesLink = !!conditionPathToChangeFieldFor || !!conditionToRefineKeyPath || isFilterFamilyPredefined;
  const showAllCategoriesLink = selectedFilterFamilyGroup || selectedFilterFamily;
  if (hasOnlyOneFilterFamilyOption || !showAllCategoriesLink) {
    return null;
  }
  if (useOnePanel && hasCombinedFilterFamilyAndFieldSelectPanel(getIsUngated)) {
    return selectedFilterFamily && selectedFilterFamilyGroup && /*#__PURE__*/_jsxs(UIBreadcrumbs, {
      className: "m-bottom-3 m-top-1",
      flush: true,
      wrapLevels: true,
      children: [/*#__PURE__*/_jsx(UILink, {
        onClick: () => resetFilterCategorySelect(false),
        children: getTopLevelFilterFamilyOptionLabel(selectedFilterFamilyGroup)
      }), /*#__PURE__*/_jsx("span", {
        children: getFilterFamilyName(selectedFilterFamily.filterFamily, baseFilterFamily === selectedFilterFamily.filterFamily && !selectedFilterFamily.isObjectOwnFilterBranch)
      })]
    });
  }
  return /*#__PURE__*/_jsxs(UIBreadcrumbs, {
    className: "m-bottom-3 m-top-1",
    flush: true,
    wrapLevels: true,
    children: [showAllCategoriesLink && /*#__PURE__*/_jsx(UILink, {
      disabled: disableAllCategoriesLink,
      onClick: () => resetFilterCategorySelect(true),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCustomerDataFilters.filterGroupEditor.breadcrumbsAllCategories"
      })
    }), selectedFilterFamilyGroup && selectedFilterFamily && /*#__PURE__*/_jsx(UILink, {
      onClick: () => resetFilterCategorySelect(false),
      children: getTopLevelFilterFamilyOptionLabel(selectedFilterFamilyGroup)
    }), selectedFilterFamilyGroup && !selectedFilterFamily && /*#__PURE__*/_jsx("span", {
      children: getTopLevelFilterFamilyOptionLabel(selectedFilterFamilyGroup)
    }), selectedFilterFamily && /*#__PURE__*/_jsx("span", {
      children: getFilterFamilyName(selectedFilterFamily.filterFamily, baseFilterFamily === selectedFilterFamily.filterFamily && !selectedFilterFamily.isObjectOwnFilterBranch)
    })]
  });
};
export default EditorFilterSelectBreadcrumbs;